import React from "react";
import { Flame, Gift } from "lucide-react";

export default function SaturdayPromo() {
  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-6">
      <div className="flex flex-col items-center gap-6">
        <p className="font-['Outfit'] text-zinc-300 text-sm uppercase tracking-[0.3em]">
          Saturday BOGO · 1080×1080
        </p>

        <div
          data-testid="promo-card"
          className="relative w-[540px] h-[540px] overflow-hidden bg-black"
        >
          {/* Background image (pulled pork sandwich) */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "url(https://static.prod-images.emergentagent.com/jobs/6ad5284b-01f5-432e-9dd7-8388ae8bdde3/images/ea2515a2333c003b27a647814b302029d3cce5e873cb14aabd10c36f28866c54.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "saturate(1.1) contrast(1.05)",
            }}
          />
          {/* Dark overlay */}
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 40%, rgba(0,0,0,0.92) 90%)",
            }}
          />
          {/* Ember vignette */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse at 50% 0%, rgba(255,59,48,0.32), transparent 60%)",
            }}
          />
          {/* Grain */}
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-25 mix-blend-screen pointer-events-none"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
            }}
          />

          {/* Brand top-left */}
          <div className="absolute top-5 left-5 flex items-center gap-2">
            <Flame
              className="text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.7)]"
              style={{ width: 18, height: 18 }}
            />
            <span
              className="font-['Anton'] uppercase text-white tracking-[0.3em]"
              style={{ fontSize: 13 }}
            >
              Smokey <span className="text-[#FF3B30]">AF</span>
            </span>
          </div>

          {/* Saturday Only ribbon top-right */}
          <div
            className="absolute top-5 right-5 bg-[#FF3B30] text-white font-['Anton'] uppercase tracking-wider px-3 py-1.5 rotate-3 shadow-[0_8px_24px_rgba(255,59,48,0.5)]"
            style={{ fontSize: 14 }}
          >
            Saturday Only
          </div>

          {/* Top headline */}
          <div className="absolute top-[58px] left-0 right-0 text-center z-10 px-6">
            <div className="flex items-center justify-center gap-2 mb-2">
              <span className="h-px w-8 bg-[#FF8C00]" />
              <Gift className="w-4 h-4 text-[#FF8C00]" />
              <span
                className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.45em]"
                style={{ fontSize: 11 }}
              >
                Free Mini Inside
              </span>
              <span className="h-px w-8 bg-[#FF8C00]" />
            </div>
          </div>

          {/* Big headline at bottom */}
          <div className="absolute inset-x-0 bottom-0 px-8 pb-8 z-10">
            <h2
              className="font-['Anton'] uppercase text-white leading-[0.85]"
              style={{ fontSize: 72, letterSpacing: "-0.02em" }}
            >
              Buy 1
              <br />
              Sandwich
            </h2>
            <h3
              className="font-['Anton'] uppercase leading-[0.85] mt-2"
              style={{
                fontSize: 56,
                letterSpacing: "-0.02em",
                color: "#FF3B30",
                textShadow: "0 0 20px rgba(255,59,48,0.5)",
              }}
            >
              Get a Mini
              <br />
              <span className="text-white">on the </span>
              House
            </h3>

            <div className="mt-5 flex items-center justify-between">
              <span
                className="font-['Anton'] tracking-widest uppercase bg-white text-black px-3 py-1.5"
                style={{ fontSize: 11 }}
              >
                Order Now
              </span>
              <span
                className="font-['Outfit'] uppercase text-zinc-300 tracking-[0.3em]"
                style={{ fontSize: 9 }}
              >
                smokey-af-bbq.emergent.host
              </span>
            </div>
          </div>
        </div>

        <a
          href="/saturday-promo.png"
          download
          className="font-['Anton'] text-sm tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 transition-colors"
        >
          Download PNG
        </a>
      </div>
    </div>
  );
}
